import { useStore } from 'stook'
import { IVehicle } from '../type'

interface IBaseInfo {
  reserveId?: string;
  frameNumber: string
  plateNumber?: string;
  selectedVehicle: null | IVehicle;
  csDesc?: string
  reserveTel: string
  reserveMan: string
  addedPlateNumber?: string
  isEditingMode?: boolean;
  contentEdited?: boolean; // 编辑过内容
}


export default function useBaseInfo() {
  const [baseInfo, setBaseInfo] = useStore<IBaseInfo>('BaseInfo', {
    reserveId: '',
    frameNumber: '',
    plateNumber: '',
    csDesc: '',
    reserveMan: '',
    reserveTel: '',
    addedPlateNumber: '',
    selectedVehicle: null,
    isEditingMode: false,
    contentEdited: false,
  })

  const setModifyReserveId = data => {
    setBaseInfo((state) => {
      state.reserveId = data;
    })
  }

  // 设置当前选中车子
  const setSelectedVehicle = data =>
    setBaseInfo((state) => {
      state.selectedVehicle = data
    })

  const setVehicle = (frameNumber, plateNumber) =>
    setBaseInfo((state) => {
      state.frameNumber = frameNumber
      state.plateNumber = plateNumber
    })

  const setCsDec = (desc) =>
    setBaseInfo((state) => {
      state.csDesc = desc
    })

  const setReserveTel = (reserveTel) =>
    setBaseInfo((state) => {
      state.reserveTel = reserveTel
    })

  const setReserveMan = (reserveMan) =>
    setBaseInfo((state) => {
      state.reserveMan = reserveMan
    })

  const addPlateNumber = (plateNumber) =>
    setBaseInfo((state) => {
      state.addedPlateNumber = plateNumber
    })
  
  const setEditingMode = (value) =>
    setBaseInfo((state) => {
      state.isEditingMode = value
    })
  
  const setContentEdited = (value) =>
    setBaseInfo((state) => {
      state.contentEdited = value
    })

  return {
    baseInfo,
    setVehicle,
    setSelectedVehicle,
    setModifyReserveId,
    setCsDec,
    setReserveMan,
    setReserveTel,
    addPlateNumber,
    setEditingMode,
    setContentEdited,
  }
}
